import { OrderTypes } from "@dana/Handlers/ProductAvailabilityHandler";
import { Cart, CartResult } from "@dana/Overrides/Services/CartService";
import ApplicationStateDana from "@dana/Store/DanaApplicationState";
import {
    addToChainAfter,
    replaceInChain
} from "@insite/client-framework/HandlerCreator";
import { del } from "@insite/client-framework/Services/ApiService";
import { clearCart, removeCartLines } from "@insite/client-framework/Services/CartService";
import loadCurrentCart from "@insite/client-framework/Store/Data/Carts/Handlers/LoadCurrentCart";
import { CallClearCart, chain, PopulateApiParameter, LoadCart } from "@insite/client-framework/Store/Pages/Cart/Handlers/ClearCurrentCart";
import { CartModel } from "@insite/client-framework/Types/ApiModels";
import { NavigationModeCookieName } from "@insite/content-library/Components/NavigationModeMenu";
import { getCookie } from "@insite/mobius/utilities/cookies";

// this will enable HMR for custom handlers
if (module.hot) {
    module.hot.accept();
    const originalChain = chain.slice();
    module.hot.dispose(data => {
        chain.length = 0;
        originalChain.forEach(o => chain.push(o));
    });
}

// trying to reference a handler not in the chain will result in a warning and the chain will not be modified
addToChainAfter(
    chain,
    PopulateApiParameter,
    props => {
        const cartMode = getCookie('cartMode');
        if (cartMode === 'EmergencyOrderCart') {
            props.apiParameter.additionalQueryStringParameters = {
                "IsEmergencyOrder": true
            }
        } else if (cartMode === 'AnnualReturnsOrderCart') {
            props.apiParameter.additionalQueryStringParameters = {
                "IsAnnualReturnsOrder": true
            }
        }

    },
);
replaceInChain(
    chain,
    CallClearCart,
    async props => {
        const currentMode = getCookie(NavigationModeCookieName);
        if (currentMode === "Vmi") {
            await removeCartLines({ ...props.apiParameter });
        } else {
            const isEmergencyOrder = (props.apiParameter?.additionalQueryStringParameters?.IsEmergencyOrder ?? false) as boolean;
            const isAnnualReturnsOrder = (props.apiParameter?.additionalQueryStringParameters?.IsAnnualReturnsOrder ?? false) as boolean;

            if (isEmergencyOrder) {
                const url = `/api/v1/carts/${props.apiParameter?.cartId}${(isEmergencyOrder ? "?IsEmergencyOrder=true" : "")}`;
                await del(url);
            } else if (isAnnualReturnsOrder) {
                const url = `/api/v1/carts/${props.apiParameter?.cartId}${(isAnnualReturnsOrder ? "?IsAnnualReturnsOrder=true" : "")}`;
                await del(url);
            } else {
                await clearCart(props.apiParameter);
            }
        }


    }
);

replaceInChain(
    chain,
    LoadCart,
    props => {
        props.dispatch(
            loadCurrentCart({
                getPromotions: false,
                onSuccess: () => {

                    const cartMode = getCookie('cartMode');
                    if (cartMode === 'EmergencyOrderCart') {

                        const state = props.getState() as ApplicationStateDana;
                        const emergencyCart = state.emergencyCartState?.cart;
                        const { cartLines, ...cart } = emergencyCart as CartModel;

                        props.dispatch?.({
                            type: "EmergencyCart/LoadResponse",
                            cart: cart as Cart,
                        } as any);

                        props.dispatch?.({
                            type: "EmergencyCart/End",
                            isLoading: false,
                            loadSuccess: true,

                        } as any);

                    } else if (cartMode === 'AnnualReturnsOrderCart') {

                        const state = props.getState() as ApplicationStateDana;
                        const annualReturnsCart = state.annualReturnsCartState?.cart;
                        const { cartLines,lineCount, ...cart } = annualReturnsCart as CartModel;
                        props.dispatch?.({
                            type: "AnnualReturnsCart/LoadResponse",
                            cart: cart as Cart,
                        } as any);

                        props.dispatch?.({
                            type: "AnnualReturnsCart/End",
                            isLoading: false,
                            loadSuccess: true,

                        } as any);

                    }
                    props.dispatch({
                        type: "Context/CompleteUpdatingCart",
                    });
                    props.dispatch({
                        type: "Pages/Cart/CompleteClearCart",
                    });
                },
            }),
        );
    }
);

